(() => {
  const reviews = document.querySelector(".tab-content--body--reviews");
  const fallback = reviews?.querySelector("[data-review-summary-fallback]");
  if (!reviews) return;

  const summarySelector =
    ".oke-w-reviewsSummaryModule, .oke-reviewsSummary, [class*='reviewsSummary']";
  const settleDelay = 900;
  const maxWait = 7000;
  let settleTimer;
  let maxTimer;
  let observer;

  const appHasSummary = () => {
    const widget = reviews.querySelector(".okeReviews.oke-w");
    return Boolean(widget?.querySelector(summarySelector)?.textContent.trim());
  };

  const finish = (force = false) => {
    const widget = reviews.querySelector(".okeReviews.oke-w");
    if (!widget && !force) {
      scheduleFinish();
      return;
    }

    window.clearTimeout(settleTimer);
    window.clearTimeout(maxTimer);
    if (fallback) fallback.hidden = appHasSummary();

    const summarySlot = widget?.querySelector(".oke-w-header-content-block--full");
    if (fallback && summarySlot && !appHasSummary()) {
      // The measured PDP left the fallback 584px left of this empty Okendo slot.
      // This move is safe after the settle window because it runs once, not during Okendo's render passes.
      summarySlot.append(fallback);
    }
    observer?.disconnect();
    reviews.classList.remove("sb-reviews-hydrating");
  };

  const scheduleFinish = () => {
    window.clearTimeout(settleTimer);

    // Okendo builds the rating, breakdown, summary copy, filters and review list
    // in several DOM and stylesheet passes. Always wait for a quiet window;
    // the summary can exist before the widget's final styles have landed.
    settleTimer = window.setTimeout(finish, settleDelay);
  };

  if (typeof MutationObserver === "undefined") {
    reviews.classList.remove("sb-reviews-hydrating");
    return;
  }
  // Okendo's runtime now waits for this panel to scroll near (see the review
  // component gate in layout/theme.liquid), so the widget can appear long after
  // load. Open the settle and max-wait windows when its markup first appears:
  // starting them at load let the 7s max strip the hydrating class before Okendo
  // had rendered, which put its intermediate relayout back on screen.
  const widgetPresent = () => Boolean(reviews.querySelector(".okeReviews.oke-w"));
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    scheduleFinish();
    maxTimer = window.setTimeout(() => finish(true), maxWait);
  };

  observer = new MutationObserver(() => {
    if (started) scheduleFinish();
    else if (widgetPresent()) start();
  });
  observer.observe(reviews, { childList: true, subtree: true });
  if (widgetPresent()) start();
})();
